import React from "react";

import AtAGlance from "./AtAGlance";
import ProgressBar from "./ProgressBar";

import { useVsiAppContext } from "../stores/VsiApp";
import { DescriptionText } from "../styled/NavBody.styled";
import { Col } from "reactstrap";
import { withErrorBoundary } from "../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../boundaries/GeneralErrorBoundary";

function NavCardGenerator({ type, stateRollupKey, stateKey, config, description }) {
  const state = useVsiAppContext();

  switch (type) {
    case "dashboard":
      return config.map((blueprints, index) => {
        const data = blueprints.fields.map(
          (field) => state?.[stateRollupKey]?.[stateKey]?.[field] || 0
        );
        return (
          <ProgressBar
            className={"mb-1"}
            data={data}
            denominator={blueprints.denominator}
            title={blueprints.title}
            colors={blueprints.colors}
            key={`progress-bar-${blueprints.title
              .toLowerCase()
              .split(" ")
              .join("-")}-${index}`}
            isMulti={blueprints.type === "multi"}
            thresholds={blueprints.thresholds}
          />
        );
      });
    case "ataglance":
      const data = state?.[stateRollupKey]?.[stateKey];
      return <AtAGlance config={config} data={data || {}} size={"sm"}/>;
    case "description":
      return <DescriptionText>{description}</DescriptionText>
    default:
      return null;
  }
}

function NavCardBody({
  col,
  config,
  stateRollupKey,
  stateKey,
  type = "",
  description = "",
}) {
  return (
    <Col {...col} className={"justify-content-center align-items-center"}>
      <NavCardGenerator
        config={config}
        stateRollupKey={stateRollupKey}
        stateKey={stateKey}
        description={description}
        type={type}
      />
    </Col>
  );
}

export default withErrorBoundary(NavCardBody, GeneralErrorBoundary);
